import React from 'react'
import PropTypes from 'prop-types'
import { toJS, observable } from 'mobx'
import ModelContext from './contexts/ModelContext'
import useModel from './hooks/use-model'
import useOperation from './hooks/use-operation'
import useOnOperationData from './hooks/use-on-operation-data'

function ModelPayload (props) {
  const parentModel = useModel()
  const parentOperation = useOperation()

  const modelRef = React.useRef(observable.map())
  const model = modelRef.current

  function loadData (data) {
    if (typeof data.model !== 'undefined') {
      model.replace(data.model)
    } else {
      model.clear()
    }
  }

  /**
     * @deprecated -> Moved to ModelProxyPayload
     */
  if (props.proxy === true && parentModel) {
    const data = {
      model: {},
      meta: parentOperation.meta
    }

    let newData = props.proxyFrom !== null
      ? parentModel.get(props.proxyFrom)
      : parentModel

    if (!newData.get || typeof newData.get !== 'function') {
      newData = observable.map(Object.entries(toJS(newData)))
    }

    newData.forEach((v, k) => {
      data.model[k] = v
    })

    loadData(data)
  }

  useOnOperationData(data => {
    loadData(data)
  })

  return (
    <ModelContext.Provider value={model}>
      <>
        {props.children}
      </>
    </ModelContext.Provider>
  )
}

ModelPayload.defaultProps = {
  proxy: false,
  proxyFrom: null
}

ModelPayload.propTypes = {
  proxy: PropTypes.bool,
  proxyFrom: PropTypes.any
}

export default ModelPayload
